import * as FilePond from "filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import axios from 'axios';

if(document.getElementById('application-form')) {
    FilePond.registerPlugin(FilePondPluginFileValidateType);
    FilePond.registerPlugin(FilePondPluginFileEncode);
    const filepond = FilePond.create(document.querySelector('.files'), {
        allowMultiple:                         true,
        instantUpload:                         false,
        required:                              true,
        acceptedFileTypes:                     ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        fileValidateTypeLabelExpectedTypesMap: {
            'image/png':                                                               '.png',
            'image/jpeg':                                                              '.jpg',
            'image/jpg':                                                               '.jpg',
            'application/pdf':                                                         '.pdf',
            'application/msword':                                                      '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx'
        },
        labelFileTypeNotAllowed:               'Onjuist bestandstype!',
        fileValidateTypeLabelExpectedTypes:    'Alleen {allButLastType} en {lastType} zijn toegstaan',
        labelIdle:                             'Sleep je cv/motivatie hiernaartoe of <span class="filepond--label-action"> blader </span>'
    });

    let currentlySending = false;

    const submitApplicationForm = (gRecaptchaResponse) => {
        const applicationForm = document.getElementById('application-form');
        if(currentlySending === false) {

            currentlySending       = true;
            const submitButton     = applicationForm.querySelector('[type="submit"]');
            submitButton.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
            submitButton.disabled  = true;
            submitButton.classList.add('disabled');

            const formData = new FormData(applicationForm);
            formData.append('g-recaptcha-response', gRecaptchaResponse)
            const validationAlert = document.getElementById('application-form-validation');

            document.querySelectorAll('.invalid-feedback').forEach((element) => {
                if(!element.classList.contains('d-none')) {
                    element.classList.add('d-none');
                }
            });

            document.querySelectorAll('.is-invalid').forEach((element) => {
                element.classList.remove('is-invalid');
            });

            validationAlert.classList.add('d-none');
            validationAlert.classList.remove('alert-danger');
            axios.post(applicationForm.action, formData).then((response) => {
                if(response.data.success) {
                    validationAlert.innerHTML = response.data.message;
                    validationAlert.classList.add('alert-success');
                    validationAlert.classList.remove('d-none');

                    applicationForm.innerHTML = '';
                }
            }).catch((exception) => {
                if(exception.response.data.errors) {
                    for(let error in exception.response.data.errors) {
                        const el = applicationForm.querySelector('[name="' + error + '"]') || applicationForm.querySelector('#' + error);
                        el.classList.add('is-invalid');
                        if(el.parentNode.querySelector('.d-none') !== null) {
                            const e = exception.response.data.errors[error][0];

                            el.parentNode.querySelector('.d-none').innerHTML = e.charAt(0).toUpperCase() + e.slice(1);
                            el.parentNode.querySelector('.d-none').classList.remove('d-none');
                        }
                    }
                }
            }).finally(() => {
                submitButton.classList.remove('disabled');
                submitButton.disabled  = false;
                submitButton.innerHTML = 'Verstuur <i class="fas fa-paper-plane"></i>';
                currentlySending       = false;
            });
        }
    };

    window.submitApplicationForm = submitApplicationForm;
}